import type { PerformanceInterface } from './index'

export class Performance implements PerformanceInterface {
  public get objects() {
    return 0
  }

  public get vertices() {
    return 0
  }

  public get triangles() {
    return 0
  }

  public get renderTime() {
    return 0
  }

  public get drawCall() {
    return 0
  }

  public get memory() {
    return 0
  }

  public get fps() {
    return 0
  }
}
